import React from "react";
import { useTranslation } from "react-i18next";
import { Package } from "lucide-react";

export default function ProductCard({ product, onAddToCart, onQuickView }) {
  const { t, i18n } = useTranslation();
  const isSoldOut = product.quantity === 0;

  return (
    <div className={`product-card group flex flex-col h-full ${isSoldOut ? 'opacity-75' : 'hover-lift'}`}>
      <div className="product-image-wrapper h-64 md:h-96 flex items-center justify-center image-zoom-container flex-shrink-0">
        {product.image ? (
          <img
            src={product.image}
            alt={product.name}
            className="h-full w-full object-cover image-zoom"
          />
        ) : (
          <div className="w-full h-full flex items-center justify-center bg-raya-bg-off">
            <Package className="w-12 h-12 text-raya-text-tertiary opacity-50" />
          </div>
        )}
        {isSoldOut && (
          <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
            <div className="bg-red-600 text-white px-8 py-4 rounded-lg transform -rotate-45 scale-150">
              <span className="text-4xl font-bold whitespace-nowrap">{t('card.soldOut')}</span>
            </div>
          </div>
        )}
        
        {/* Quick View Overlay on Hover */}
        {!isSoldOut && onQuickView && (
          <button 
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onQuickView(product);
            }}
            aria-label="Quick View"
            className="absolute inset-0 w-full h-full bg-black bg-opacity-0 group-hover:bg-opacity-20 transition-all duration-300 flex items-center justify-center opacity-0 group-hover:opacity-100 cursor-pointer border-none"
          >
            <div className="transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
              <span className="text-raya-text-primary text-sm font-semibold bg-raya-card border border-raya-border hover:border-raya-accent px-6 py-3 rounded-full transition-all shadow-xl z-10">
                Quick View
              </span>
            </div>
          </button>
        )}
      </div>

      <div className="p-4 flex flex-col flex-grow">
        <h3 className="font-semibold text-lg mb-2 line-clamp-2">
          {i18n.language === 'am' && product.name_am 
            ? product.name_am 
            : t(`products.${product.name}.name`, { defaultValue: product.name })}
        </h3>
        <p className="text-raya-text-secondary text-sm mb-3 line-clamp-2">
          {i18n.language === 'am' && product.description_am 
            ? product.description_am 
            : t(`products.${product.name}.description`, { defaultValue: product.description })}
        </p>

        <div className="mb-3 flex items-center gap-2 mt-auto">
          <span className="text-sm text-raya-text-tertiary">
            {t('card.stock')} <span className={`font-semibold ${product.quantity > 0 ? 'text-green-600' : 'text-red-600'}`}>
              {product.quantity > 0 ? product.quantity : 0}
            </span>
          </span>
          {product.quantity > 0 && <span className="stock-badge">In Stock</span>}
        </div>

        <div className="flex justify-between items-center mt-2">
          <span className="product-price">
            ${product.price}
          </span>
          <button
            onClick={() => onAddToCart(product)}
            disabled={isSoldOut}
            className={`btn-add-to-cart ${
              isSoldOut
                ? 'opacity-50 cursor-not-allowed'
                : 'hover:scale-105 active:scale-95'
            }`}
          >
            {isSoldOut ? t('card.soldOut') : t('card.addToCart')}
          </button>
        </div>
      </div>
    </div>
  );
}
